export const Home_REQUEST='Home_REQUEST';
export const Home_FAILURE='Home_FAILURE';
export const GET_Home_SUCCESS='GET_Home_SUCCESS';